import { render, staticRenderFns } from "./RushPlayerRaces.vue?vue&type=template&id=5bc2f894&"
import script from "./RushPlayerRaces.vue?vue&type=script&lang=js&"
export * from "./RushPlayerRaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports